import store from '../../../../store'
import { ref, watch, computed } from '@vue/composition-api'
import useRouter from '../../../../core/hooks/useRouter'
import { EMPTY_STATES } from '../../../../core/utils/dashboard.utils'

const useEmptyState = () => {
    const { route } = useRouter()
    const emptyState = ref({})
    const publishedCampaignIds = computed(() => store.state.publishedCampaignIds)

    watch([route, publishedCampaignIds], ([route, publishedCampaignIds]) => {

        if(publishedCampaignIds && !publishedCampaignIds.length && route.name === 'requests') {
            return emptyState.value = {
                ...EMPTY_STATES.noCampaign,
                type: 'noCampaign',
            }
        }

        if(route.name === 'requests' && (route.query.type === 'received' || !route.query.type)) {
            if(publishedCampaignIds.length === 1) {
                emptyState.value = {
                    ...EMPTY_STATES.receivedRequest,
                    texts: {
                        text1: 'You don’t have a receieved Request yet.',
                        text2: `Make sure you have <a href="/edit-campaign?id=${publishedCampaignIds[0].id}&model=campaign" target="_blank">scheduled updates.</a>`,
                        text3: 'Be proactive! <a href="/" target="_blank">Request Crossproms.</a>'
                    },
                    icon: EMPTY_STATES.receivedRequest.icon
                }
            }

            if(publishedCampaignIds.length > 1) {
                emptyState.value = {
                    ...EMPTY_STATES.receivedRequest,
                    texts: {
                        text1: 'You don’t have a receieved Request yet.',
                        text2: `Make sure you have <a href="/dashboard/campaigns/publish">scheduled updates.</a>`,
                        text3: 'Be proactive! <a href="/" target="_blank">Request Crossproms.</a>'
                    }
                }
            }
            return emptyState
        }

        if(route.name === 'requests' && route.query.type === 'sent') {
            return emptyState.value = EMPTY_STATES.sentRequest
        }

        if(route.name === 'updates' && (route.query.type === 'scheduled' || !route.query.type)) {
            return emptyState.value = EMPTY_STATES.scheduledUpdates
        }

        if(route.name === 'updates' && route.query.type === 'unscheduled') {
            return emptyState.value = EMPTY_STATES.notScheduledUpdates
        }


    }, {immediate: true})

    return {
        emptyState
    }
}   

export default useEmptyState